import React from 'react';

interface AppRouterProps {
  children: React.ReactNode;
}

export const AppRouter: React.FC<AppRouterProps> = ({ children }) => {
  // Simply render the normal app content - no invitation signup needed
  return <>{children}</>;
};